__turbopack_context__.v({
  "cards": "kCqibq_cards",
  "container": "kCqibq_container",
  "info": "kCqibq_info",
  "statBrackets": "kCqibq_statBrackets",
  "statResults": "kCqibq_statResults",
  "stats": "kCqibq_stats",
});
